import gql from 'graphql-tag'

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser (
    $id: Int!,
    $firstName: String,
    $firstNameKana: String,
    $lastName: String,
    $lastNameKana: String,
    $email: String,
    $telNumber: String,
    $isActive: Boolean
    $ownerOfPropertyId: Int
  ){
    updateUser(
      data: {
        id: $id,
        firstName: $firstName,
        lastName: $lastName,
        firstNameKana: $firstNameKana,
        lastNameKana: $lastNameKana,
        email: $email,
        isActive: $isActive,
        telNumber: $telNumber
        ownerOfPropertyId: $ownerOfPropertyId
      }
    ) {
      id
      email
      firstName
      firstNameKana
      lastName
      lastNameKana
      telNumber
      isActive
    }
  }
`
